import React from "react";
import { FaHtml5, FaCss3Alt, FaJsSquare, FaReact, FaPhp, FaGithub } from "react-icons/fa";
import { SiTailwindcss, SiBootstrap, SiMysql, SiLaravel, SiWordpress, SiCanva, SiPostman } from "react-icons/si";
import { VscCode } from "react-icons/vsc";
import { useTranslation } from "react-i18next";

const Skills = () => {
  const iconGradientStyle = {
    fill: "url(#iconGradient)",
  };

  const textGradientStyle = {
    background: "linear-gradient(to right, #808080, #ADD8E6)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  };

  const { t } = useTranslation();

  return (
    <section id="skills" className="relative overflow-hidden py-4">
      <div className="relative z-20 w-full max-w-6xl mx-auto flex flex-col justify-center gap-8 px-4 ">
        <div className="text-center text-white">
          <h2
            className="text-2xl sm:text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight
             text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400 mt-0 sm:mt-8 mb-8"
            data-aos="fade-down"
          >
            {t("skills.title")}
          </h2>

          {/* Separatore */}
          <div
            className="w-48 h-1 mx-auto md:mb-12 bg-gradient-to-r from-transparent via-purple-300 to-transparent"
            data-aos="fade-up"
          ></div>
        </div>

        <div className="flex flex-col md:flex-row gap-12 items-center md:items-start mt-2">
          <div className="md:w-1/2 text-white text-center md:text-left">
            <p
              className="md:mt-2 text-base sm:text-base md:text-lg text-gray-200 leading-relaxed px-6"
              data-aos="fade-right"
              data-aos-delay="400"
            >
              {t("skills.description")}
            </p>
          </div>

          <div className="md:w-1/2 flex flex-col items-center p-2" data-aos="fade-left" data-aos-delay="800">
            <svg width="0" height="0">
              <linearGradient id="iconGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#808080" />
                <stop offset="100%" stopColor="#ADD8E6" />
              </linearGradient>
            </svg>

            <h4 className="text-xl md:text-2xl font-bold tracking-tight mb-8 text-center" style={textGradientStyle}>
              {t("skills.technologiesTitle")}
            </h4>
            <div className="flex flex-wrap justify-center gap-8 mb-12" data-aos="fade-left" data-aos-delay="400">
              {[
                { icon: FaHtml5, label: "HTML5" },
                { icon: FaCss3Alt, label: "CSS3" },
                { icon: FaJsSquare, label: "JavaScript" },
                { icon: FaReact, label: "React" },
                { icon: SiBootstrap, label: "Bootstrap" },
                { icon: SiTailwindcss, label: "Tailwind CSS" },
                { icon: FaPhp, label: "PHP" },
                { icon: SiWordpress, label: "WordPress" },
                { icon: SiMysql, label: "MySQL" },
                { icon: SiLaravel, label: "Laravel" },
              ].map(({ icon: Icon, label }, i) => (
                <div key={i} className="flex flex-col items-center group cursor-pointer">
                  <Icon
                    className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 transition-all duration-300 group-hover:brightness-125 group-hover:saturate-150"
                    style={iconGradientStyle}
                  />

                  <span className="mt-2 text-sm text-gray-400 group-hover:text-white transition-colors duration-300">
                    {label}
                  </span>
                </div>
              ))}
            </div>

            <div data-aos="fade-left">
              <h4 className="text-xl md:text-2xl font-bold tracking-tight mb-8 text-center" style={textGradientStyle}>
                {t("skills.utilitiesTitle")}
              </h4>
              <div className="flex flex-wrap justify-center gap-8">
                {[
                  { icon: VscCode, label: "VS Code" },
                  { icon: FaGithub, label: "GitHub" },
                  { icon: SiCanva, label: "Canva" },
                  { icon: SiPostman, label: "Postman" },
                ].map(({ icon: Icon, label }, i) => (
                  <div key={i} className="flex flex-col items-center group cursor-pointer">
                    <Icon
                      className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 transition-all duration-300 group-hover:brightness-125 group-hover:saturate-150"
                      style={iconGradientStyle}
                    />

                    <span className="mt-2 text-sm text-gray-400 group-hover:text-white transition-colors duration-300">
                      {label}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
